import React, {Component} from 'react'
import {Bar} from 'react-chartjs-2'
import * as PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import MuiTable from "../common/MuiTable";
import {NotificationManager} from "react-notifications";
import {organisationDetails, saveOrUpdateOrganisationDetails} from "../../util/ApiUtils";

const months = { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' };

const data = {
    labels: [],
    datasets: [
        {
            label: 'Corrective Actions',
            backgroundColor: '#1a73e8',
            borderColor: '#1a73e8',
            borderWidth: 1,
            hoverBackgroundColor: '#1a73e8',
            hoverBorderColor: '#d93025',
            data: []
        },
        {
            label: 'Nonconformance Actions',
            backgroundColor: '#d93025',
            borderColor: '#d93025',
            borderWidth: 1,
            hoverBackgroundColor: '#d93025',
            hoverBorderColor: '#1a73e8',
            data: []
        }
    ]
};

const options = {
    scales: {
        yAxes: [{
            scaleLabel: {
                display: true,
                labelString: 'No of Actions'
            },
            ticks: {
                min: 0
            }
        }],
        xAxes: [{
            scaleLabel: {
                display: true,
                labelString: 'Date'
            }
        }],
    }
}

const muiColumns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    { title: 'Month', field: 'month', lookup: { 'Jan': 'Jan', 'Feb': 'Feb', 'Mar': 'Mar', 'Apr': 'Apr', 'May': 'May', 'Jun': 'Jun', 'Jul': 'Jul', 'Aug': 'Aug', 'Sep': 'Sep', 'Oct': 'Oct', 'Nov': 'Nov', 'Dec': 'Dec' }},
    { title: 'Year', field: 'year'},
    { title: '# of Corrective Actions', field: 'corrActions', headerStyle: { width: "25%" } },
    { title: '# of Nonconformance Actions', field: 'nonconfActions', headerStyle: { width: "25%" } },
];

class CorrectiveActions extends Component {

    constructor(props) {
        super(props);
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log('organisation response', response);
                let sorted = response.actions.sort(function(a, b) {
                    let am = Object.keys(months).find(key => months[key] === a.month)
                    let bm = Object.keys(months).find(key => months[key] === b.month)
                    return a.year - b.year || am - bm;
                });
                console.log('sorted actions', response.actions);
                data.labels = [];
                data.datasets[0].data = [];
                data.datasets[1].data = [];
                sorted.forEach((element) => {
                    data.labels.push(element.month + ' ' + element.year)
                    data.datasets[0].data.push(element.corrActions)
                    data.datasets[1].data.push(element.nonconfActions)
                })
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    actions: sorted,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    isValid(newData) {
        let isValid = newData.month && newData.month !== '' && newData.year
            && newData.year !== '' && newData.corrActions && newData.corrActions !== ''
            && newData.nonconfActions && newData.nonconfActions !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Please enter all the required fields', 5000);
        }
        return isValid;
    }

    handleUpdate(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.actions.length; i < l; i++) {
            if (this.state.organisation.actions[i].id === toUpdate.id) {
                this.state.organisation.actions[i].month = toUpdate.month;
                this.state.organisation.actions[i].year = toUpdate.year;
                this.state.organisation.actions[i].corrActions = toUpdate.corrActions;
                this.state.organisation.actions[i].nonconfActions = toUpdate.nonconfActions;
            }
        }
        console.log("After update:", this.state.organisation.actions);
        this.handleSubmit(this.state.organisation.actions);
    }

    handleDelete(toDelete) {
        let actions = [];
        const index = this.state.organisation.actions.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.actions.length; i < l; i++) {
            if (i !== index) {
                actions.push(this.state.organisation.actions[i]);
            }
        }
        console.log("After removal:", actions);
        this.handleSubmit(actions);
    }

    handleAdd(data) {
        this.state.organisation.actions.push(data);
        this.handleSubmit(this.state.organisation.actions);
    }

    handleSubmit(data) {
        this.state.organisation.actions = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success('Success', 'The Data have been updated.', 5000);
                this.loadOrganisationDetails();
                this.props.onChanged(this.state.organisation.actions);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    render() {
        return (
            // A react-chart hyper-responsively and continuously fills the available
            // space of its parent element automatically
            <div>
                {this.props.isEdit ?
                    <React.Fragment>
                        <Paper style={{ marginTop: '30px' }}>
                            <MuiTable
                                title="Customer Complaints"
                                columns={muiColumns}
                                data={this.state.actions}
                                onAdd={this.handleAdd}
                                onUpdate={this.handleUpdate}
                                onDelete={this.handleDelete}
                                isValid={this.isValid}
                                exportButton={false}
                                search={false}
                                pageSize={20}
                                headerStyle={{ background: "lightblue" }}
                            />
                        </Paper>
                    </React.Fragment>
                    :
                    <Bar
                        data={data}
                        width={400}
                        height={300}
                        options={options}
                        redraw
                    />}
            </div>
        )};
}

CorrectiveActions.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    onChanged: PropTypes.func.isRequired,
}
export default CorrectiveActions;
